import React, { useState } from "react";
import MuiAlert, { AlertProps as MuiAlertProps } from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useAlert } from "../../hooks/alertHooks";

type Severity = MuiAlertProps["severity"];

interface AlertProps {
  message: string;
  severity: Severity;
}

function Alert(props: AlertProps) {
  const { message, severity } = props;
  const { removeAlert } = useAlert();
  const [open, setOpen] = useState(true);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    removeAlert();
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={severity}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
}


export default Alert;